// The one way the studio shows that something could not be loaded or saved: a quiet neutral row, the lead in bold,
// the reason in the secondary label and one "Try again". No red: colour means a department (and red reads as Draft).
export function ErrorRow({
  title,
  detail,
  onRetry,
  className = "",
}: {
  title: string;
  detail?: string;
  onRetry?: () => void;
  className?: string;
}) {
  return (
    <div className={`err-row ${className}`.trim()} role="alert">
      <div className="err-text">
        <strong className="err-title">{title}</strong>
        {detail && <p>{detail}</p>}
      </div>
      {onRetry && (
        <button type="button" className="btn small" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}
